import appLocalStorage from './appLocalStorage'

export function authHeader () {
  let store = JSON.parse(appLocalStorage.getStore())

  if (store && store.authentication) {
    let user = store.authentication.user

    if (user && user.token) {
      return {
        'pragma': 'no-cache',
        'cache-control': 'no-cache',
        'Authorization': 'Bearer ' + user.token
      }
    }
  }

  return {}
}
